// src/aws/guestCredentialProvider.js
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import debugLogger from "../../utils/debug";

debugLogger.log('Initializing guest credential provider', {
  region: process.env.REACT_APP_REGION,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID ? '***' + process.env.REACT_APP_IDENTITY_POOL_ID.slice(-8) : 'Missing'
});

export const guestCredentialProvider = fromCognitoIdentityPool({
  client: new CognitoIdentityClient({ region: process.env.REACT_APP_REGION }),
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
});


